export function consoleInfo() {
    console.log(
        `%c vue-resume  %c 联系QQ：854806732 %c 联系微信：eveningwater %c 或者扫描下方二维码加入群吧 %c `,
        'background:#0ca6dc ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
        'background:#ff7878 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
        'background:#ff7878 ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
        'background:#ff7878 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
        'background:transparent',
    )
    console.log("%c ", "padding:50px 50px;border-radius:5px;background:url(https://www.eveningwater.com/img/code.png)no-repeat;background-size:cover;")  
}